import {
  ColdArticleEntity,
  FocusEntity,
  FooterEntity,
  HeaderEntity,
  HomeEntity,
  HotArticleEntity,
  HubActusEntity,
  HubEntity,
  HubNewsroomEntity,
  InvestorsDashboardEntity,
  InvestorsEntity,
  InvestorsMatrixEntity,
  InvestorsMenuEntity,
  InvestorsTabContentEntity,
  InvestorsTableEntity,
  LaPosteEn4Entity,
  MediaPopinEntity,
  MediaPressEntity,
  NewsroomEntity,
  PressReleaseEntity,
  ProfileEntity,
  RSEEntity,
  SearchEntity,
  SliderPopinEntity,
  TimelinePopinEntity,
  TranslationEntity,
  VideoPopinEntity,
} from '@lglp/prismic-client';
import { schema } from 'normalizr';

import { DocumentType, TranslationType } from '../../../types/document';
import { toDocType } from '../mapping';
import {
  ContactEntity,
  FinancialDebtEntity,
  FinancialKeyFiguresEntity,
  FinancialPressReleaseEntity,
  FinancialPublicationEntity,
  FinancialRatingEntity,
} from './documents';
// import { PressReleaseEntity } from './documents/press-release';

const isTranslation = (type?: string): boolean =>
  type.startsWith('translation_');

/**
 * Normalizr schema representing a document
 */
export const CustomType = new schema.Union(
  {
    [DocumentType.CONTACT]: ContactEntity,
    [DocumentType.COLD_ARTICLE]: ColdArticleEntity,
    [DocumentType.INVESTORS]: InvestorsEntity,
    [DocumentType.INVESTORS_DASHBOARD]: InvestorsDashboardEntity,
    [DocumentType.INVESTORS_MATRIX]: InvestorsMatrixEntity,
    [DocumentType.INVESTORS_MENU]: InvestorsMenuEntity,
    [DocumentType.INVESTORS_TAB_CONTENT]: InvestorsTabContentEntity,
    [DocumentType.INVESTORS_TABLE]: InvestorsTableEntity,
    [DocumentType.FINANCIAL_DEBT]: FinancialDebtEntity,
    [DocumentType.FINANCIAL_KEY_FIGURES]: FinancialKeyFiguresEntity,
    [DocumentType.FINANCIAL_PRESS_RELEASE]: FinancialPressReleaseEntity,
    [DocumentType.FINANCIAL_PUBLICATION]: FinancialPublicationEntity,
    [DocumentType.FINANCIAL_RATING]: FinancialRatingEntity,
    [DocumentType.FOOTER]: FooterEntity,
    [DocumentType.FOCUS]: FocusEntity,
    [DocumentType.HEADER]: HeaderEntity,
    [DocumentType.HOME]: HomeEntity,
    [DocumentType.HOT_ARTICLE]: HotArticleEntity,
    [DocumentType.HUB]: HubEntity,
    [DocumentType.HUB_ACTUS]: HubActusEntity,
    [DocumentType.HUB_NEWSROOM]: HubNewsroomEntity,
    [DocumentType.LA_POSTE_EN_4]: LaPosteEn4Entity,
    [DocumentType.MEDIA_POPIN]: MediaPopinEntity,
    [DocumentType.MEDIA_PRESS]: MediaPressEntity,
    [DocumentType.NEWSROOM]: NewsroomEntity,
    [DocumentType.PRESS_RELEASE]: PressReleaseEntity,
    [DocumentType.PROFILE]: ProfileEntity,
    [DocumentType.RSE]: RSEEntity,
    [DocumentType.SEARCH]: SearchEntity,
    [DocumentType.SLIDER_POPIN]: SliderPopinEntity,
    [DocumentType.TIMELINE_POPIN]: TimelinePopinEntity,
    [DocumentType.VIDEO_POPIN]: VideoPopinEntity,

    [TranslationType.TRANSLATION]: TranslationEntity,
  },
  (entity) => {
    if (isTranslation(entity?.type)) {
      return TranslationType.TRANSLATION;
    }
    return toDocType(entity?.type);
  }
);

/**
 * Normalizr schema representing an array of documents
 */
export const CustomTypes = [CustomType];
